import { useSession } from 'next-auth/react';
const useAccessToken = (): string | null => useSession().data?.accessToken ?? null;
export default useAccessToken;
